// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3xXPr","title":"AfterBackImages_title__zXp4-","images":"AfterBackImages_images__1y2uX"};